require("!!/usr/src/cube/node_modules/script-loader/addScript.js")(require("!!/usr/src/cube/node_modules/raw-loader/index.js!/usr/src/cube/src/legacy/common/cartridge.legacy.js"))


//////////////////
// WEBPACK FOOTER
// ./src/legacy/common/cartridge.legacy.js
// module id = 616
// module chunks = 31